import { Component, Inject } from '@angular/core';
import { AuthenticationService, CONFIG_ENV } from '@core/service';
import { IEnvironmentVariables } from 'src/environments/IEnvironment';
import { FeatureToggleService, SecurityService } from '@mynexus/mynexus-ui-lib';
import { FeatureFlags } from '@core/enumeration'

@Component({
    selector: 'referral-welcome-page',
    templateUrl: './referral-welcome-page.component.html',
    styleUrls: ['./referral-welcome-page.component.scss'],
    standalone: false
})
export class ReferralWelcomePageComponent {

  constructor(
    @Inject('windowRef') private window: Window,
    @Inject(CONFIG_ENV) private configEnv: IEnvironmentVariables,
    private readonly authenticationService: AuthenticationService,
    private readonly securityService: SecurityService,
    private readonly featureToggleService: FeatureToggleService
  ) { }

  readonly featureFlag = FeatureFlags;

  public starsFeatureFlag: boolean;

  ngOnInit(): void {
    this.featureToggleService.getFeatureAccess(this.featureFlag.STARs)
      .subscribe((isEnabled: boolean) => {
        this.starsFeatureFlag = isEnabled;
      });
  }

  openReferralDashboard() {
    this.window.open(this.configEnv.sdohUrl);
  }

  get isReferralDashboardHidden(): boolean {
      if(!this.starsFeatureFlag){
        if(!this.isWCCExternal && !this.isSDoHorReferralProgramAdmin && this.isStars){
            return false;
        }
    }
    return true;
  }

  get isWCCExternal(): boolean {
    return this.authenticationService.isWCCExternal;
  }

  get isStars(): boolean {
    return this.authenticationService.isStarsClinician
    || this.authenticationService.isStarsProviderAdminInternal
    || this.authenticationService.isStarsOpsUser;
  }

  get isSDoHorReferralProgramAdmin(): boolean {
    return this.authenticationService.isSdohUserExternal
    || this.authenticationService.isReferralProgramProviderAdmin
      || this.isWCCExternal;
  }
}
